import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { ClpCompany, CompanyResponse } from '../../../models/company.model';
import { Contact } from '../../../models/contact.model';
import { eFeatures, eUserRole } from '../../../models/enum.model';
import { SimpleDataType, SimpleResponse } from '../../../models/genericResponse.model';
import { EmailSettings, EmailSettingsResponse } from '../../../models/note.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { EngageEmailUnsubscribe, EngageUnSubSetupResponse } from '../../../models/engage-post.model';
import { AccountSetupService } from '../../../services/accountSetup.service';
import { ContactService } from '../../../services/contact.service';
import { GlobalService } from '../../../services/global.service';
import { NotesService } from '../../../services/notes.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { EngagePostService } from '../../../services/engage-post.service';
import { UserService } from '../../../services/user.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-engage-unsub',
    templateUrl: './engage-unsub.component.html',
    styleUrls: ['./engage-unsub.component.css']
})
/** engage-unsub component*/
export class EngageUnsubComponent {
    eUserRole = eUserRole;
    showSpinner: boolean = false;
    private encryptedUser: string = '';
    user: CLPUser;
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;


    unsubForm: FormGroup;
    cLPCompanyID: number;
    clpCompanyID: number;
    contactID: number;
    contactData: Contact;
    mailingEmailId: string;
    companyData: ClpCompany;
    clpUserData: CLPUser;
    emailSettings: EmailSettings = <EmailSettings>{};
    phFxString: string;
    message: string;
    emailAddress: string;
    strPHToFix: SimpleDataType = <SimpleDataType>{}
    sOEmailUnsubscribe: EngageEmailUnsubscribe = <EngageEmailUnsubscribe>{}
    pnlEmailEdit: boolean = false;
    private destroy$ = new Subject<void>();

    constructor(
        public _localService: LocalService,
        private _utilityService: UtilityService,
        private _route: ActivatedRoute,
        private _router: Router,
        public engagePostService: EngagePostService,
        public fb: FormBuilder,
        public _contactService: ContactService,
        public _accountSetupService: AccountSetupService,
        public userService: UserService,
        public notesService: NotesService,
        public _globalService: GlobalService

    ) {
        this._localService.isMenu = false;
    }

    ngOnInit() {
        this.unsubForm = this.prepareUnsubForm();
        this.setupPage();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    async setupPage() {
        let blnGo = false

        let strURLVar = ""
        let strURLKey = ""

        let sbOut = ''
        let cLPCompanyID = -1
        this._route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(async params => {
            let strContactIDCode = ""
            let strContactID = ""
            if (params.dcm) {
                strContactIDCode = params.dcm
            }
            if (params.cid) {
                strContactID = params.cid
            }

            sbOut = sbOut + "strContactIDCode: " + strContactIDCode + "<br />"
            sbOut = sbOut + "strContactID: " + strContactID + "<br />"

            if (strContactIDCode != '') {
                strURLVar = 'dcm'
                strURLKey = strContactIDCode

                await this.engageUnSubnUnConvertCodeToID(strContactIDCode.toLowerCase(), true)
                cLPCompanyID = this.clpCompanyID
                blnGo = true
                console.log(this.contactID);
                if (this.contactID == 0) {
                    cLPCompanyID = -1
                    blnGo = false

                    if (strContactID! = '') {
                        strURLVar = "cid"
                        strURLKey = strContactID
                        this.contactID = +strContactID
                        if (this.contactID > 0) {
                            blnGo = true
                        }
                    }
                    else {
                        this.contactID = 0;
                    }
                }

                sbOut = sbOut + "CLPCompanyID: " + cLPCompanyID + "<br />"
                sbOut = sbOut + "ContactID: " + this.contactID + "<br />"
            }
            else if (strContactID != '') {
                strURLVar = "cid"
                strURLKey = strContactID
                this.contactID = +strContactID
                blnGo = true;
            }

            if (blnGo && this.contactID > 0) {
                await this.engageUnSubSetup(strContactIDCode, this.contactID)
            }
            if (blnGo && this.contactID > 0) {
                //await this.contactLoad()
                if (Object.keys(this.contactData)?.length > 0) {
                    if (cLPCompanyID != -1) {
                        if (this.contactData?.cLPCompanyID != cLPCompanyID) {
                            blnGo = false
                        }
                    }
                    else {
                        cLPCompanyID = this.contactData.cLPCompanyID
                    }
                    if (blnGo) {
                        if (this.contactData?.cLPCompanyID != 1226) {
                            let strEmail = this.mailingEmailId
                            let strTop = `We're sorry to see you go!  Are you sure you wish to stop ALL emails to <b>${strEmail}</b>?`
                            if (this.emailSettings?.prefsMainDesc != '') {
                                this.strPHToFix.messageString1 = this.emailSettings?.prefsMainDesc
                                this.strPHToFix.messageInt1 = this.companyData?.cLPCompanyID
                                this.strPHToFix.messageInt2 = this.contactData?.contactID
                                this.strPHToFix.messageInt3 = this.clpUserData?.cLPUserID
                                await this.pHFixString()
                                strTop = this.phFxString
                            }
                            if (this.emailSettings?.prefsInfoDesc != '') {
                                this.strPHToFix.messageString1 = this.emailSettings?.prefsInfoDesc
                                this.strPHToFix.messageInt1 = this.companyData?.cLPCompanyID
                                this.strPHToFix.messageInt2 = this.contactData?.contactID
                                this.strPHToFix.messageInt3 = this.clpUserData?.cLPUserID
                                await this.pHFixString()
                                strTop = this.phFxString
                            }
                            if (this.emailSettings?.prefsPromoDesc != '') {
                                this.strPHToFix.messageString1 = this.emailSettings?.prefsPromoDesc
                                this.strPHToFix.messageInt1 = this.companyData?.cLPCompanyID
                                this.strPHToFix.messageInt2 = this.contactData?.contactID
                                this.strPHToFix.messageInt3 = this.clpUserData?.cLPUserID
                                await this.pHFixString()
                                strTop = this.phFxString
                            }
                            if (strEmail?.startsWith('noemail')) {
                                if (strEmail.trim() != '') {
                                    this.message = strTop
                                }
                                else {
                                    if (this.contactData.email != '') {
                                        strEmail = this.contactData.email
                                        this.message = strTop
                                    }
                                    else if (this.contactData.email2 != '') {
                                        strEmail = this.contactData.email2
                                        this.message = strTop
                                    }
                                    else if (this.contactData.email3 != '') {
                                        strEmail = this.contactData.email3
                                        this.message = strTop
                                    }
                                    else {
                                        this.message = "We have received your unsubscribe request and have removed your email from our mailing lists."
                                    }
                                }
                            }
                            else {
                                this.message = "We have received your unsubscribe request and have removed your email from our mailing lists."
                            }
                            this.emailAddress = strEmail
                        }
                        else {
                            blnGo = true
                        }
                    }
                    else {
                        this.message = "We have received your unsubscribe request and have removed your email from our mailing lists."
                    }
                }
                else {
                    this.message = "We have received your unsubscribe request and have removed your email from our mailing lists."
                }
            }
            console.log(this.contactID);
        })


        if (!blnGo) {
            this.pnlEmailEdit = true;
            this.message = "We're having trouble identifying your information.  Please provide us with as much information so we can unsubscribe you. <br /><br />Note: SafeMail Unsubscribe&trade; from Engage adheres to our anti-spam policy to follow industry best practices and protect the delivery of legitimate email to its intend recipients."
        }
    }

    prepareUnsubForm() {
        return this.fb.group({
            txtEmail: [''],
            txtUserInfo: [''],
            cbInfo: [false],
            cbPromo: [false],
            txtReason: ['']
        })
    }

    submitUnsubForm() {
        this.sOEmailUnsubscribe = <EngageEmailUnsubscribe>{}
        this.sOEmailUnsubscribe.cbInfo = this.unsubForm.controls.cbInfo.value
        this.sOEmailUnsubscribe.cbPromo = this.unsubForm.controls.cbPromo.value
        this.sOEmailUnsubscribe.contactId = this.contactID;
        this.sOEmailUnsubscribe.emailId = this.unsubForm.controls.txtEmail.value
        this.sOEmailUnsubscribe.unsubscribeReason = this.unsubForm.controls.txtReason.value

        this.engageUnSub()
    }

    async engageUnSubSetup(strContactIDCode = "", contactID = 0) {
        return this.engagePostService.engageUnSubSetup(strContactIDCode, contactID)
            .then(async (result: EngageUnSubSetupResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.contactData = result?.contact;
                    this.companyData = result?.cLPCompany;
                    this.emailSettings = result?.emailSettings;
                    this.mailingEmailId = result?.email
                }
            }).catch((err: HttpErrorResponse) => {
                this._globalService.error("so-unsub.soUnSubnUnConvertCodeToID", err.message, null, 'strContactIDCode ' + strContactIDCode);;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async engageUnSubnUnConvertCodeToID(strContactIDCode, blnSuppressErrorEmail) {
        return this.engagePostService.engageUnSubnUnConvertCodeToID(this.encryptedUser, strContactIDCode, blnSuppressErrorEmail)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.clpCompanyID = UtilityService.clone(result?.messageInt);
                    this.contactID = result?.messageInt2;
                }
            }).catch((err: HttpErrorResponse) => {
                this._globalService.error("engage-unsub.engageUnSubnUnConvertCodeToID", err.message, null, 'strContactIDCode ' + strContactIDCode + 'blnSuppressErrorEmail ' + blnSuppressErrorEmail);;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async engageUnSub() {
        return this.engagePostService.engageUnSubSave(this.encryptedUser, this.sOEmailUnsubscribe)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    if (result.messageBool) {
                        this._router.navigateByUrl(`eml-pref-confirm?uid=${this.contactData?.cLPUserID}`);
                    }
                    else {
                        this._router.navigateByUrl(`eml-pref-confirm?uid`);
                    }

                }
            }).catch((err: HttpErrorResponse) => {
                this._globalService.error("so-unsub.sOUnSub", err.message, this.sOEmailUnsubscribe);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async pHFixString() {
        this.showSpinner = true;
        return this.engagePostService.pHFixString(this.encryptedUser, this.strPHToFix)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.phFxString = result?.messageString;
                }
            }).catch((err: HttpErrorResponse) => {
                this._globalService.error("engage-unsub.pHFixString", err.message, null, 'strPHToFix ' + this.strPHToFix);;
                this._utilityService.handleErrorResponse(err);
            });
    }

}
